module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 001.20cedc0e.jpg";